import React from 'react';
import Badge from '../../components/UI/Badge';

export default function CandidateCard({ candidate, onSelect, selected, onStatusChange, showMatchScore }) {
	const name = candidate.sections?.personalInfo?.name || 'Candidate';
	const skills = (candidate.sections?.skills || []).flatMap((c) => c.items || []).slice(0, 6);
	const score = candidate.matchScore || candidate.atsScore || 0;
	const scoreVariant = score > 75 ? 'success' : score >= 50 ? 'warning' : 'danger';

	return (
		<div className="border rounded p-3 hover:shadow-md transition bg-white">
			<div className="flex items-start justify-between">
				<div className="flex items-center gap-3">
					<input type="checkbox" checked={selected} onChange={(e) => onSelect?.(e.target.checked)} />
					<div className="w-10 h-10 rounded-full bg-gray-200" />
					<div>
						<p className="font-semibold">{name}</p>
						<p className="text-xs text-gray-500">{candidate.sections?.personalInfo?.location}</p>
					</div>
				</div>
				{showMatchScore && <Badge text={`${score}%`} variant={scoreVariant} />}
			</div>
			<div className="mt-2 flex flex-wrap gap-2">
				{skills.map((s, i) => (
					<Badge key={i} text={s} variant="info" />
				))}
			</div>
			<div className="mt-3 text-xs text-gray-500">Uploaded: {new Date(candidate.createdAt || Date.now()).toLocaleDateString()}</div>
			<div className="mt-2">
				<select className="border rounded px-2 py-1 text-sm" value={candidate.candidateStatus || 'new'} onChange={(e) => onStatusChange?.(e.target.value)}>
					{['new', 'reviewed', 'shortlisted', 'interviewed', 'offered', 'rejected'].map((st) => (
						<option key={st} value={st}>
							{st}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}


